import React, { useEffect } from 'react';
import FacilityPage from '../components/FacilityPage';

const NightClub: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Night Club"
      description="The atmosphere is electric, with state-of-the-art lighting, sound systems, and DJ booths that create an immersive and unforgettable experience. Our night club is the perfect destination for those looking to dance the night away and enjoy premium cocktails in a vibrant setting."
      features={[
        "State-of-the-art sound system",
        "Professional DJ setups",
        "Dynamic lighting effects",
        "Premium bar service",
        "Spacious dance floor",
        "VIP seating areas",
        "Regular themed nights and events",
        "Late night entertainment"
      ]}
      images={["/images/facilities/night-club.jpg"]}
    />
  );
};

export default NightClub;